function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9885 11.2057C21.9885 10.3044 21.9137 9.64668 21.7517 8.9646H11.2192V13.0328H17.4015C17.2769 14.0437 16.6039 15.5663 15.1081 16.5894L15.0871 16.7256L18.4173 19.2466L18.648 19.2691C20.7669 17.3568 21.9885 14.5431 21.9885 11.2057Z",
  fill: "#4285F4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2192 21.9245C14.248 21.9245 16.7907 20.95 18.648 19.2692L15.1081 16.5895C14.1608 17.2351 12.8894 17.6857 11.2192 17.6857C8.25267 17.6857 5.73487 15.7735 4.83735 13.1304L4.70579 13.1413L1.24304 15.76L1.19775 15.8831C3.04247 19.464 6.83167 21.9245 11.2192 21.9245Z",
  fill: "#34A853"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.83713 13.1303C4.60031 12.4482 4.46325 11.7174 4.46325 10.9622C4.46325 10.207 4.60031 9.47622 4.82467 8.79413L4.81839 8.64886L1.31225 5.98804L1.19753 6.04136C0.437236 7.52737 0.000976562 9.19609 0.000976562 10.9622C0.000976562 12.7284 0.437236 14.397 1.19753 15.883L4.83713 13.1303Z",
  fill: "#FBBC05"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2192 4.23869C13.3256 4.23869 14.7466 5.12785 15.5568 5.87089L18.7227 2.85018C16.7783 1.08405 14.248 0 11.2192 0C6.83166 0 3.04247 2.46039 1.19775 6.04135L4.82489 8.79412C5.73487 6.15102 8.25267 4.23869 11.2192 4.23869Z",
  fill: "#EB4335"
});

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b5b804d1.svg";
export { ForwardRef as ReactComponent };